(function () {
  function resolveExternalUrl(option, localeCode) {
    var url = option.getAttribute('data-external-url');
    if (!url) return url;

    if (!localeCode) return url;

    var match = url.match(/^(https?:\/\/[^/]+)\/([a-z]{2})-([a-z]{2})(?=\/|$)/i);
    if (!match) return url;

    return url.replace(
      /^(https?:\/\/[^/]+)\/([a-z]{2})-([a-z]{2})(?=\/|$)/i,
      match[1] + '/' + localeCode + '-' + match[3]
    );
  }

  function parseLanguages(option) {
    if (!option) return [];

    var raw = option.getAttribute('data-languages');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) {}
    }

    if (!option.hasAttribute('data-external-url')) return [];

    var url = option.getAttribute('data-external-url') || '';
    var match = url.match(/\/([a-z]{2})-[a-z]{2}(?=\/|$)/i);
    if (!match) return [];

    return [{ iso: match[1], name: match[1].toUpperCase() }];
  }

  function syncLanguages(countrySelect, localeSelect) {
    var option = countrySelect.options[countrySelect.selectedIndex];
    if (!option) return;

    var languages = parseLanguages(option);
    if (!languages.length) return;

    var previous = localeSelect.value;
    var stillAvailable = languages.some(function (lang) {
      return lang.iso === previous;
    });

    localeSelect.innerHTML = '';
    languages.forEach(function (lang) {
      var opt = document.createElement('option');
      opt.value = lang.iso;
      opt.setAttribute('lang', lang.iso);
      opt.textContent = lang.name;
      if (stillAvailable && lang.iso === previous) {
        opt.selected = true;
      }
      localeSelect.appendChild(opt);
    });

    if (!stillAvailable) {
      localeSelect.selectedIndex = 0;
    }
  }

  function initLanguageSync(form) {
    var countrySelect = form.querySelector('select[name="country_code"]');
    var localeSelect = form.querySelector('select[name="locale_code"]');
    if (!countrySelect || !localeSelect) return;

    if (countrySelect.dataset.languageSyncInit === 'true') return;
    countrySelect.dataset.languageSyncInit = 'true';

    function onCountryChange() {
      syncLanguages(countrySelect, localeSelect);
    }

    countrySelect.addEventListener('change', onCountryChange);
    onCountryChange();
  }

  function initAllLanguageSync() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.querySelector('select[name="country_code"]') && form.querySelector('select[name="locale_code"]')) {
        initLanguageSync(form);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-external-url]');
    if (!target || target.tagName === 'OPTION') return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = target.getAttribute('data-external-url');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var countrySelect = form.querySelector('select[name="country_code"]');
    if (!countrySelect) return;

    var option = countrySelect.options[countrySelect.selectedIndex];
    var externalUrl = option && option.getAttribute('data-external-url');
    if (!externalUrl) return;

    event.preventDefault();

    var localeSelect = form.querySelector('select[name="locale_code"]');
    var localeCode = localeSelect && localeSelect.value;
    window.location.href = resolveExternalUrl(option, localeCode);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllLanguageSync);
  } else {
    initAllLanguageSync();
  }
})();
